export default {
  get(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/lesson/" + id)
        .then((response) => {
          context.commit("setLesson", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
